import { createReducer, on } from '@ngrx/store';
import * as fromActions from '../actions';
import { AuthState } from '../models/store.models';

const initialState : AuthState = {
  auth: null
}
export function authReducer(state = initialState, action: fromActions.AuthActions): AuthState {

  switch (action.type) {
    case fromActions.SET_AUTHENTICATED:
      
      return {
        auth: action.usuarioAutenticado
      }
    case fromActions.UNSET_AUTHENTICATED:
      return {
        auth: null
      }
    default:
      return state;
  }
}

